// extracted by mini-css-extract-plugin
export default {"file-downloader":"IWMUy","file-downloader__button":"UR8Wl","file-downloader__text":"egRnh"};